<template>
  <div v-if="siteAndDepartment.length">
    <div
      v-for="(item, index) in siteAndDepartment"
      :key="index"
      :class="{
        'custom-margin-bottom-6': index !== siteAndDepartment.length - 1,
      }"
    >
      <span class="text-semibold-black">{{ item.siteName }}</span>
      <ul class="custom-padding-left-18 mb-0">
        <li class="font-size-12">
          {{ item.departmentName }}
        </li>
      </ul>
    </div>
  </div>
  <div v-else>
    <span class="text-semibold-black">Site not found</span>
  </div>
</template>

<script>
export default {
  name: "MoleculeSiteAndDepartmentDisplay",
  props: {
    siteAndDepartment: {
      type: Array,
      required: true,
    },
  },
}
</script>

<style lang="scss" scoped></style>
